import { render, staticRenderFns } from "./liburterbit.vue?vue&type=template&id=d9a6443a"
import script from "./liburterbit.vue?vue&type=script&lang=js"
export * from "./liburterbit.vue?vue&type=script&lang=js"
import style0 from "./liburterbit.vue?vue&type=style&index=0&id=d9a6443a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports